import CryptoJS from "crypto-js";

const characters =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

const key = process.env.hasOwnProperty("REACT_APP_KEY")
  ? process.env.REACT_APP_KEY
  : "";
const salt = process.env.hasOwnProperty("REACT_APP_SALT")
  ? process.env.REACT_APP_SALT
  : "";
const symmetricKey = process.env.hasOwnProperty("REACT_APP_SYMMETRIC_KEY")
  ? process.env.REACT_APP_SYMMETRIC_KEY
  : "";

export const getPayloadHash = ({ data = {} }) => {
  const hash = CryptoJS.MD5(key + salt);

  let payload = {
    salt: salt,
    sign: hash.toString(),
    ...data,
  };

  return btoa(encodeURIComponent(JSON.stringify(payload)));
};

export const encryptor = ({ payload = "" }) =>
  CryptoJS.AES.encrypt(JSON.stringify(payload), symmetricKey);

export const decryptor = ({ encryptedData = "" }) => {
  const decrypted = CryptoJS.AES.decrypt(
    encryptedData.toString(),
    symmetricKey
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const generateRandomString = (length = 10) => {
  try {
    if (isNaN(length) || length > 50) {
      return null;
    }

    let result = "";
    const charLen = characters.length;

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charLen);
      result += characters.charAt(randomIndex);
    }

    return result;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const convertDateOrder = (
  date,
  currentOrder = ["y", "m", "d"],
  order = ["y", "m", "d"],
  splitter = "-"
) => {
  if (
    !date ||
    date.split(splitter).length !== 3 ||
    order.length !== 3 ||
    !order.includes("y") ||
    !order.includes("m") ||
    !order.includes("d") ||
    currentOrder.length !== 3 ||
    !currentOrder.includes("y") ||
    !currentOrder.includes("m") ||
    !currentOrder.includes("d")
  )
    return null;

  const dateArr = date.split(splitter);
  let d = dateArr[currentOrder.indexOf("d")];
  let m = dateArr[currentOrder.indexOf("m")];
  let y = dateArr[currentOrder.indexOf("y")];

  let newOrder = ["", "", ""];
  for (let i = 0; i < order.length; i++) {
    if (order[i] === "y") {
      newOrder[i] = y;
    }
    if (order[i] === "m") {
      newOrder[i] = m;
    }
    if (order[i] === "d") {
      newOrder[i] = d;
    }
  }

  return newOrder.join("-");
};

export const _HHMMSS_To_HHMM = (time) => {
  let [hh, mm] = time.split(":");
  return [hh, mm].join(":");
};

export const _24To12 = (time) => {
  let [hour, minute] = time.split(":").map(Number);
  let period = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;
  return `${hour}:${minute.toString().padStart(2, "0")} ${period}`;
};

export const getMinutesFromSeconds = (sec) => {
  if (!sec) {
    return `0 seconds`;
  }

  let mins = Math.floor(sec / 60);
  let remainingSeconds = sec % 60;

  return `${mins} min${mins > 0 ? "s" : ""} ${remainingSeconds} second${
    remainingSeconds > 0 ? "s" : ""
  }`;
};
